






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {ReponsavelAssociado} from '@/model/resource/ReponsavelAssociado'
import {InputReponsavelAssociadoSchema} from '@/schema/resource/ReponsavelAssociado/InputReponsavelAssociadoSchema'

@Component
export default class PersistReponsavelAssociadoView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputReponsavelAssociadoSchema()
  reponsavelAssociado = new ReponsavelAssociado()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionResponsavel.listResponsavel()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.reponsavelAssociado.getReponsavelAssociado(id)
    }

    $.await.done('getReponsavelAssociado')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.reponsavelAssociado.persistReponsavelAssociado()
    await Helper.successAndPush(
      'system.success.persist',
      '/reponsavel-associado/list'
    )
  }
}
